export const updateTableSelector = ({ table }) => table;
export const tablePaginationSelector = ({ table }) =>  table.tablePagination;
